export default "__VITE_ASSET__zjhzIId3__"